import { createTheme } from "@material-ui/core";

export const theme = createTheme({
  palette: {
    primary: {
      main: "#2962ff",
      contrast: "#fda513",
    },
  },
});
